import React from 'react';
export const Streams = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="2.08925" cy="2.03994" r="2.03994" fill="currentColor" />
    <circle cx="11.1691" cy="2.03994" r="2.03994" fill="currentColor" />
    <circle cx="2.08925" cy="11.1198" r="2.03994" fill="currentColor" />
    <circle cx="11.1691" cy="11.1198" r="2.03994" fill="currentColor" />
  </svg>
);
